import { useAtomValue, useSetAtom } from 'jotai';
import { Button } from '@/components/ui/button';
import { Briefcase } from 'lucide-react';
import {
  assignmentsSearchQueryAtom,
  fetchAssignmentsActionAtom,
} from '@/stores/assignmentsStore';

export interface AssignmentEmptyStateProps {
  activeTab: string;
}

export function AssignmentEmptyState({ activeTab }: AssignmentEmptyStateProps) {
  const searchQuery = useAtomValue(assignmentsSearchQueryAtom);
  const fetchAssignments = useSetAtom(fetchAssignmentsActionAtom);

  const handleRefresh = () => {
    fetchAssignments().catch(console.error);
  };

  return (
    <div className='text-center py-12'>
      <Briefcase className='h-16 w-16 text-muted-foreground mx-auto mb-4 opacity-50' />
      <div className='text-muted-foreground mb-4'>
        {searchQuery
          ? `No assignments found matching "${searchQuery}"`
          : `No ${activeTab === 'all' ? '' : activeTab} assignments found.`}
      </div>
      <Button variant='outline' onClick={handleRefresh}>
        Refresh Assignments
      </Button>
    </div>
  );
}
